import { Modal } from "@/components/Modal"
import { useHistory } from "react-router-dom"

export const VerifyModal = () => {
  const history = useHistory()
  return (
    <Modal onClose={() => history.push("/cards")} show title="Order Card">
      <div className="text-black text-[16px] max-w-[500px] mt-3">
        To initiate a card order, kindly ensure that your accout is verified.
        <br />
        For verification, please get in touch with our Compliance Department at verify{" "}
        <a className="text-main-main" href="mailto:verify@tranzbase.com">
          verify@tranzbase.com
        </a>
        .
      </div>
    </Modal>
  )
}
